/**
 * @generated SignedSource<<20061935a4444530960cc8b7f48a5980>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_viewer";
};
export type PdpRespSidebarBlurbs_viewer$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9994f04976554d694381c25e6534790a";

export default node;
